module.exports = __webpack_public_path__ + "img/link.972a7c23.svg";